import adMarker from "../../../../../../../assets/svg/scheduling/adMarker.svg";
import promoMarker from "../../../../../../../assets/svg/scheduling/promoMarker.svg";

export const AdMarker = ({
    data,
    calculateMinutes,
    zoomInOut,
    viewType
}) => {
    if (!data?.adBreaks?.length) return null;
    return data.adBreaks.map((item) => {
        if (item?.type === "ad" || item?.type === "filler" || item?.type === "promo") {
          const style = {
            position: "absolute",
            zIndex: item?.adSqId,
            top: `${calculateMinutes(item?.startOffsetInMillis) * zoomInOut}px`,
            height: "0px",
            left: `${viewType === "expandView" ? "-0.2vw" : "-0.5vw"}`,
          };
    
          const imgStyle = {
            position: "absolute",
            top: "-5px",
          };
    
          return (
            <span key={item?.adSqId} style={style}>
                {
                    item?.type === "promo"?
                    <img src={promoMarker} width={25} style={imgStyle} />
                    :
                    <img src={adMarker} width={25} style={imgStyle} />
                }
            </span>
          );
        }
        return null;
    });
}